import styled from "styled-components"


const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  .menu-item{
    width: auto;
    display: flex;
    align-items: center;
    width: 20%;


    .round{
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid ${({theme}) => theme.mainTextColor};
        position: relative;

        .menu-name{
          position: absolute;
          top: -50%;
          left: 50%;
          transform: translate(-50%, -100%);
          font-size: 14px;
          font-weight: var(--font-weight-xl);
          width: max-content;
        }
    }

    .seperator{
        width: calc(100% - 15px);
        border-top: 1px dashed #000;
    }


  }

  .active{
    background-color: rebeccapurple;
  }
`
const MenuItem = styled.div`
    width: auto;
    display: flex;
    align-items: center;
    width: 20%;

    .round{
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid ${({isActiveName}) => isActiveName ? "var(--color-main)" : "#000"};
        position: relative;
        background-color: ${({theme, isActiveName}) => isActiveName ? "var(--color-main)" : theme.rotaPointColor};
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;



        .menu-name-wrapper{
          position: absolute;
          top: -50%;
          left: 50%;
          transform: translate(-50%, -100%);
          font-size: 14px;
          font-weight: var(--font-weight-xl);
          width: max-content;
          color: ${({theme, isActiveName}) => isActiveName ? "var(--color-main)" : theme.mainTextColor};

          .menu-name{
            position: relative;

            .error-list-count{
              position: absolute;
              top: -10px;
              right: -21px;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background-color: var(--color-main);
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
            }

          }
        }
    }

    .seperator{
        width: calc(100% - 15px);
        border-top: 1px  ${({isActiveLine}) => isActiveLine ? "solid": "dashed"}  ${({theme,isActiveLine}) => isActiveLine ? "var(--color-main)":  theme.mainTextColor};
    }

`


const MenuSection = ({setPhase, phase, menuList}) => {
  return (
    <Container>
      {
        menuList.map((item) => (
          <MenuItem isActiveLine={item.id <= phase.id -1} isActiveName={(item.id <= phase.id || item.id === phase.id)}>
                <div className={item.errorList.length > 0 ? "round round-big" : "round" } onClick={(e) => {e.stopPropagation(); setPhase({name: item.name, id: item.id})}}>
                  
                    <div className="menu-name-wrapper">
                      <div className="menu-name" onClick={(e) => {e.stopPropagation(); setPhase({name: item.name, id: item.id})}}>{item.name}
                      {
                      item.errorList.length > 0 &&
                      <span className="error-list-count">{item.errorList.length}</span>
                    }
                      </div>
                    </div>
                </div>
                {
                  item.id !== 6 && 
                  <div className="seperator"></div>
                }
          </MenuItem>
        ))
      }
    </Container>
  )
}

export default MenuSection